import { render, staticRenderFns } from "./sync-setup.vue?vue&type=template&id=1d35f19f&scoped=true"
import script from "./sync-setup.js?vue&type=script&lang=js&external"
export * from "./sync-setup.js?vue&type=script&lang=js&external"
import style0 from "./sync-setup.css?vue&type=style&index=0&id=1d35f19f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d35f19f",
  null
  
)

/* custom blocks */
import block0 from "./sync-setup.vue?vue&type=custom&index=0&blockType=meta&name=robots&content=noindex"
if (typeof block0 === 'function') block0(component)
import block1 from "./sync-setup.vue?vue&type=custom&index=1&blockType=meta&name=robots&content=nofollow"
if (typeof block1 === 'function') block1(component)
import block2 from "./sync-setup.vue?vue&type=custom&index=2&blockType=meta&name=robots&content=noindex%2Cnofollow"
if (typeof block2 === 'function') block2(component)

export default component.exports